"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = _interopRequireDefault(require("../styles"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _tokens = require("../styles/tokens");
var _excluded = ["classes", "text"];
var styles = function styles() {
  return {
    h1: {
      marginTop: _tokens.spacing60,
      marginBottom: _tokens.spacing50
    }
  };
};

/**
 * Use `PageHeader` to display a page title at the top of a page.
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.0.8
 * @examples
 *  PageHeaderExample
 */
var PageHeader = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  var classes = props.classes,
    text = props.text,
    rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
  var classOverrides = (0, _extends2.default)({
    h1: classes.h1
  }, classes);
  return /*#__PURE__*/_react.default.createElement(_Typography.default, (0, _extends2.default)({}, rest, {
    classes: classOverrides,
    variant: "h1",
    ref: ref
  }), text);
});
PageHeader.muiName = 'PageHeader';
PageHeader.displayName = 'PageHeader';
PageHeader.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,
  /**
   * The content to be displayed as the page header.
   */
  text: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object, _propTypes.default.bool])), _propTypes.default.func, _propTypes.default.object])
};
var _default = exports.default = (0, _styles.default)(styles)(PageHeader);